import React from 'react';
import ProfileRecommendationCard from 'buyside/components/presentation/ProfileRecommendationCard/profileRecommendationCard';

const FundProfileCardRecommendation = props => {
  return (
    <ProfileRecommendationCard
      {...props}
      ProfileCard={props.card}
      Profile={props.node.fundProfile}
      ProfileType="Buyside"
    />
  );
};

export default FundProfileCardRecommendation;
